module.exports = __webpack_public_path__ + "img/rux-how-to.7286cab3.jpg";